module.exports = __webpack_public_path__ + "img/img-01@3x.4cfd85b4.png";